import React, { useState } from 'react';
import cx from 'classnames';
import {connect} from 'react-redux';
import SliderContext from './context'
import Content from './Content'
import SlideButton from './SlideButton'
import SliderWrapper from './SliderWrapper'
import useSliding from './useSliding'
import useSizeElement from './useSizeElement'
import withRouter from '../common/withRouter';
import './Slider.scss'


/*
{hasPrev && <SlideButton onClick={handlePrev} type="prev" />}
        {hasNext && <SlideButton onClick={handleNext} type="next" />}

*/
const Slider = ({ children, activeSlide  }) => {

    
  const [currentSlide, setCurrentSlide] = useState(activeSlide);
  const { width, elementRef } = useSizeElement();
    
  const {
    handlePrev,
    handleNext,
    slideProps,
    containerRef,
    hasNext,
    hasPrev
  } = useSliding(width, React.Children.count(children));

  const handleSelect = movie => {
    setCurrentSlide(movie);
  };

  const handleClose = () => {
    setCurrentSlide(null);
  };

  const contextValue = {
    onSelectSlide: handleSelect,
    onCloseSlide: handleClose,
    elementRef,
    currentSlide,
  };
    
     //onsole.log("hasPrev"+hasPrev);
      //console.log("hasNext"+hasNext);
  
  return (
      

      
    <SliderContext.Provider value={contextValue}>
      <SliderWrapper>
        <div
          className={cx('slidernf', { 'slidernf--open': currentSlide != null })}
        >
          <div ref={containerRef} className="slidernf__container" {...slideProps}>{children}</div>
        </div>
       <SlideButton onClick={handlePrev} type="prev" />
        <SlideButton onClick={handleNext} type="next" />
      </SliderWrapper>
      {currentSlide && <Content  movie={currentSlide} onClose={handleClose} />}
    </SliderContext.Provider>
  );
};
         

export default (withRouter(Slider));
